import { CheckoutSessionProductDescription } from '@/modules/billing/constants/CheckoutSessionProductDescription';
import { ProductKey } from '@/modules/estate/enums/ProductKey';
import Lang from '@/modules/core/app/services/Lang';

export class ProtectionMandateProductDescription extends CheckoutSessionProductDescription {
  get exclusions(): string[] {
    return [Lang.t('billing.notarized-hard-doc')];
  }

  get inclusions(): string[] {
    return [
      Lang.t('billing.appointment-mandatary-property'),
      Lang.t('billing.appointment-mandatary-person'),
      Lang.t('billing.notarization-document-1')
    ];
  }

  productKey = ProductKey.INDIVIDUAL_PROTECTION_MANDATE;

  get legalDisclaimer(): string {
    return Lang.t('billing.protection-mandate-legal');
  }

  get subtitle(): string {
    return Lang.t('estate.for-individuals');
  }

  get title(): string {
    return Lang.t('document.protection-mandate');
  }
}

export default new ProtectionMandateProductDescription();
